import { render, staticRenderFns } from "./PublicShareAuthSidebar.vue?vue&type=template&id=3e83db39&scoped=true&"
import script from "./PublicShareAuthSidebar.vue?vue&type=script&lang=js&"
export * from "./PublicShareAuthSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PublicShareAuthSidebar.vue?vue&type=style&index=0&id=3e83db39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e83db39",
  null
  
)

export default component.exports